<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
  >
    <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`/accreditations/process/quotation/update/${inputs.id}`"
      >
        <div class="row" v-if="evaluationList && evaluationList.length > 0">
          <div class="col-12">
            <app-note
              class="pt-2 clearfix"
              :title="$t('Procesos en bloque')"
              content-type="html"
              note-type="note-warning"
              :notes="[
                $t(
                  'Al realizar la aceptación de la proforma se efectuará la misma acción para las siguientes evaluaciones o testificaciones'
                ),
              ]"
            />
          </div>
          <br />
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">Expediente</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Código</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in evaluationList" :key="key">
                  <td class="align-middle">
                    {{ value.accreditation_applications.record }}
                  </td>
                  <td class="align-middle">
                    <br />
                    <p v-if="value.type == 'E'">Evaluación</p>
                    <p v-if="value.type == 'T'">Testificación</p>
                  </td>
                  <td class="align-middle">{{ value.code }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <legend>
          <p class="text-primary">Documentos anteriores</p>
        </legend>
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th>FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inputs.evaluation_team_file">
              <td class="align-middle">Propuesta del Equipo Evaluador</td>
              <td class="align-middle">
                {{ inputs.evaluation_team_file.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  :href="
                    inputs && inputs.evaluation_team_file
                      ? inputs.evaluation_team_file.full_url
                      : ''
                  "
                  class="btn btn-success btn-md"
                  target="_blank"
                  @click="inputs.evaluation_team_file ?
                  saveFile(inputs.evaluation_team_file.path) : ''"
                >
                  <app-icon name="file"></app-icon> Ver
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <br /><br />
        <legend>
          <p class="text-primary">Proforma de servicios</p>
        </legend>

        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th>FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inputs.proforma">
              <td class="align-middle">Proforma de Servicios</td>
              <td class="align-middle">
                {{ inputs.proforma.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  :href="
                    inputs && inputs.proforma ? inputs.proforma.full_url : ''
                  "
                  class="btn btn-success btn-md"
                  target="_blank"
                  @click="inputs.proforma ?
                  saveFile(inputs.proforma.path) : ''"
                >
                  <app-icon name="file"></app-icon> Ver
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <br /><br />
        <legend
          v-if="
            inputs.eval_annexes_files && inputs.eval_annexes_files.length > 0
          "
        >
          <p class="text-primary">Anexos de personal externo</p>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="
            (inputs.eval_annexes_files && inputs.eval_annexes_files.length > 0) || (inputs.evaluation_team && Array.isArray(inputs.evaluation_team) && inputs.evaluation_team.some(item => item.evaluation_team_external))
          "
        >
          <thead>
            <tr>
              <th scope="col">NOMBRE</th>
              <th>FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in inputs.eval_annexes_files" :key="key">
              <td class="align-middle">{{ item.filename }}</td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  :href="item.annexed.full_url"
                  class="btn btn-success btn-md"
                  target="_blank"
                >
                  <app-icon name="file"></app-icon> Ver
                </a>
              </td>
            </tr>
            <tr v-for="ext in inputs.evaluation_team" :key="ext.id">
                <td class="align-middle" v-if="ext.evaluation_team_external">
                  {{
                      ext.evaluator
                        ? `${ext.evaluator.first_name} ${ext.evaluator.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle" v-if="ext.evaluation_team_external">
                  {{ ext.evaluation_team_external.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center" v-if="ext.evaluation_team_external">
                  <button type="submit" class="btn btn-success" @click.prevent="openTabExt(ext,'evaluation_team_external')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
          </tbody>
        </table>
        <!-- <div class="row" v-if="inputs.proforma_additional_file">
          <div class="col-12">
            <div class="form-group text-center">
              <p class="card-title m-0">
                <strong>Honorarios Personal Externo</strong>
              </p>
              <br />
              <a
                :href="
                  inputs && inputs.proforma_additional_file
                    ? inputs.proforma_additional_file.full_url
                    : ''
                "
                class="btn btn-success btn-md"
                target="_blank"
              >
                <app-icon name="file"></app-icon> Ver
              </a>
            </div>
          </div>
        </div> -->

        <div class="mb-primary" v-if="!hideMsg">
          <app-note
            class="pt-2 clearfix"
            title="Información"
            content-type="html"
            note-type="note-red"
            :notes="[$t('error_note_proform')]"
          />
        </div>
        <div class="form-group text-center">
          <label for="inputs_name" class="col-sm-12 mb-0">
            <h5 class="card-title m-0"><strong>ACEPTA LA PROFORMA?</strong></h5>
            <br />
          </label>
          <app-input
            id="inputs_approved"
            class="col-sm-12"
            type="radio-buttons"
            :list="listOptions"
            @input="clicked"
            v-model="inputs.approved"
            :required="true"
          />
        </div>

        <div class="form-group row text-center" v-if="inputs.approved == 2">
          <label for="inputs_name" class="col-sm-12 mb-0">
            <h5 class="card-title m-0">¿Es una modificación de proforma.?</h5>
            <br />
          </label>
          <app-input
            id="inputs_gestion_modification"
            class="col-sm-12"
            type="radio-buttons"
            :list="listOptionsSystem"
            v-model="inputs.gestion_modification"
            :required="true"
          />
        </div>

        <div class="form-group row align-items-center" v-if="!hide">
          <label for="inputs_name" class="col-sm-12 mb-0">
            <h5 class="card-title m-0">
              Justificación del rechazo de la Proforma
            </h5>
          </label>
          <app-input
            id="inputs_observations"
            class="col-sm-12"
            type="textarea"
            v-model="inputs.observations_203"
            :required="true"
          />
        </div>
      </form>
    </template>
    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ProformaModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  filters: {
    dateFormat: function (value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD HH:mm");
      }
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      hide: true,
      hideMsg: true,
      showAdditional: false,
      modalId: "proforma-review-modal",
      modalTitle: this.$t("add"),
      evaluationList: "",
      listOptions: [
        { id: "2", value: "No" },
        { id: "1", value: "Si" },
      ],
      listOptionsSystem: [
        {
          id: "2",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
    };
  },
  created() {
    this.modalTitle = this.$t("Aprobar Proforma");
  },
  methods: {
    clicked(event) {
      if (this.inputs.approved === "2") {
        this.hide = false;
      } else {
        this.hide = true;
      }
    },
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (response.status == 200) {
        this.$toastr.s("Registro actualizado exitosamente.");
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      if (Number(this.inputs.proform_reject_counter) >= 1) {
        this.hideMsg = false;
      }
      if (
        response.data.evaluationList &&
        response.data.evaluationList.length > 0
      ) {
        this.evaluationList = response.data.evaluationList;
      }
      this.preloader = false;
    },
    saveFile(file) {
      let info = {};
      info['accAppId'] = null;
      info['evalTestId'] = this.inputs.id;
      info['path'] = String(file);
      this.$store.dispatch("registerFileLog", info);
    },
    openTabExt(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },
  },
};
</script>
